import { DragZoom } from 'ol/interaction';

/**
 * Extends the standard DragZoom interaction included in OpenLayers:
 * When constructed without any parameters, does not require pressed shift key to work (needed for use in DragZoomAction)
 */
export class DragZoomInteraction extends DragZoom {

  constructor (requireShiftKey = false) {
    super({ condition: !requireShiftKey && (() => true) });
  }

}
